<template>
  <div style="height: 0" id="pages" class="panel-pages">
    <div
      class="panel__left show_panel gjs-pn-panel gjs-pn-panel-top gjs-one-bg gjs-two-color"
      id="panel__left"
    >
      <div
        class="panel__list-page gjs-pn-panel gjs-pn-panel-basic gjs-one-bg gjs-two-color"
        id="panel__list-page"
        v-show="opened"
      >
        <custom-segment-panel-pages
          v-if="$route.name === 'segment'"
          @transitionSelected="addTransition"
          :is-edit-segement="isEditSegement"
        ></custom-segment-panel-pages>
        <custom-panel-pages
          v-show="$route.name !== 'segment'"
          @transitionSelected="addTransition"
        ></custom-panel-pages>
      </div>
    </div>
    <transition-modal v-if="showModal" @close="showModal = false" :slide="selectedSlideTransition">
    </transition-modal>
  </div>
</template>

<script>
import TransitionModal from '../Modal/TransitionModal';
import CustomSegmentPanelPages from './CustomSegmentPanelPages.vue';
import mixin from '../../mixins/Mixin.js';
import CustomPanelPages from './CustomPanelPages';

export default {
  components: { CustomPanelPages, CustomSegmentPanelPages, TransitionModal },
  mixins: [mixin],
  props: { isEditSegement: null },
  data() {
    return {
      opened: true,
      showModal: false,
      selectedSlideTransition: {},
    };
  },

  methods: {
    showPanel() {
      this.opened = !this.opened;
      var imgArrow = document.querySelector('.imgClickAndChange');
      var panelScreen = document.getElementById('panel__left');
      var canvas = document.querySelector('.canvas-div');
      var infos = document.getElementById('list-informations');
      var infos_fieldset = document.querySelector('#list-informations > fieldset');
      var infos_new = document.getElementById('list-informations-new');
      var blocks = document.querySelector(
        '.gjs-pn-panel.gjs-pn-views-container.gjs-one-bg.gjs-two-color',
      );
      if (imgArrow && imgArrow.classList.contains('rotate')) {
        document.querySelector('#list-informations-new').classList.remove('rotate');
        document.querySelector('#list-informations').classList.remove('rotate');
        imgArrow.classList.remove('rotate');
        panelScreen.classList.remove('hidden-panel');
        canvas.classList.remove('full-panel');
        infos.classList.remove('hide-infos');
        if(infos_fieldset)
          infos_fieldset.classList.remove('hide-infos-fieldset');
        blocks.classList.remove('full-panel-blocks');
        blocks.classList.add('display-panel-blocks');
        infos_new.classList.remove('display-infos-new');
      } else {
        document.querySelector('#list-informations-new').classList.add('rotate');
        document.querySelector('#list-informations').classList.add('rotate');
        imgArrow.classList.add('rotate');
        panelScreen.classList.add('hidden-panel');
        canvas.classList.add('full-panel');
        infos.classList.add('hide-infos');
        if(infos_fieldset)
          infos_fieldset.classList.add('hide-infos-fieldset');
        blocks.classList.add('full-panel-blocks');
        blocks.classList.remove('display-panel-blocks');
        infos_new.classList.add('display-infos-new');
      }
      setTimeout(() => {
        this.updateCanvasDimensions();
      }, 150);
    },
    showPanelContainer() {
      let panelElement = document.querySelector(
        '.gjs-pn-panel.gjs-pn-views-container.gjs-one-bg.gjs-two-color',
      );
      let canvasElement = document.querySelector('.gjs-cv-canvas');
      let panelSlidesElement = document.querySelector('div#panel__left.show_panel');
      let panelButtons = document.querySelector('.gjs-pn-panels .panel-buttons');
      let toggleButtons = document.getElementById('btn-toggle');
      panelElement.classList.add('show-blocks-panels');
      panelElement.classList.remove('hide-blocks-panels');
      panelSlidesElement.classList.remove('hide_panel');
      canvasElement.classList.add('show-canvas');
      panelButtons.classList.add('show-panel-buttons');
      toggleButtons.classList.remove('rotate-buttons');
      toggleButtons.classList.add('resize-panel-buttons');
    },
    addTransition(segment) {
      this.selectedSlideTransition = segment;
      this.showModal = true;
    },
  },
  created() {
    this.$root.$on('show-panels-container', () => {
      this.showPanelContainer();
    });
    this.$root.$on('showPanel', () => {
      this.showPanel();
    });
    eventHub.$on('eventaAddTransition', val =>{
      this.addTransition(val)
    });


  },
};
</script>

<style lang="scss">
@import '../../scss/media-queries';
@import '../../scss/variables';
#panel__left {
  padding: 42px 0 0;
  width: 0;
  height: $height-custom-panel;
  line-height: 1.5;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  display: none !important;
  &.show_panel {
    width:100%;
    background: #f5f5f5;
    display: block !important;
    bottom: 0px;
    padding-top: 5px;
    max-height: 122px;

  }
  &.hide_panel {
    width: calc(100% - 50px);
  }
  &.hidden-panel {
    height: 1% !important;
  }
  #panel__list-page {
    position: absolute;
    bottom: 0;
    z-index: 100;
    line-height: 1.5;
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s cubic-bezier(0.18, 1.2, 1, 1);
    background: #f0f0f0;
    color: #222;
    font-size: 14px;
    height: $height-custom-panel;
    padding: 0;
    width: 100%;
    left: 0;
    & > div {
      display: flex;
      .btn-generic {
        border: 2px solid #2196f3 !important;
        margin: 12px 5px !important;
        border-radius: 5px;
        font-size: 32px;
        color: #2196f3;
        &.filled {
          background-color: #2196f3;
          color: #ffffff;
        }
      }
    }
  }
}
.full-panel {
  height: calc(100% - 50px) !important;
}
</style>



// WEBPACK FOOTER //
// PanelWrapper.vue?7c6da546